export const PLATFORM_ENVIRONMENT_ROOT_PROD: string = 'https://yatta.de';
export const PLATFORM_ENVIRONMENT_BACKEND_API_ROOT_PROD: string = 'https://api.yatta.de';
